import React from 'react'
import image_404 from "../../assets/images/404_image.png" 
import Navbar from '../../components/Navbar/Navbar'

// 404 - Page Not Found
const PageNotFound = () => {
  return (
    <main>
      <Navbar />

      <div className='h-[calc(100vh-100px)] w-full flex items-center justify-center container'>
        <img src={image_404} alt="page not found" className='max-h-[600px] min-w-[300px] max-w-[500px]' />
      </div>
    </main>
  )
}

export default PageNotFound